export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCjLPCBt3y-IEWa8qB-UBTUI5DoXyma8Oo",
    authDomain: "talenttrace-development.firebaseapp.com",
    projectId: "talenttrace-development",
    storageBucket: "talenttrace-development.appspot.com",
    messagingSenderId: "685110656707",
    appId: "1:685110656707:web:0c304c73ceda5821656c76"
  }
};
